export const statusLabels = {
  nao_iniciado: "Não Iniciado",
  em_andamento: "Em Andamento",
  concluido: "Concluído",
  suspenso: "Suspenso",
  cancelado: "Cancelado",
  aprovado: "Aprovado",
};

export const statusVigentes = ["nao_iniciado", "em_andamento", "aprovado"];
export const statusGestao = ["nao_iniciado", "em_andamento", "aprovado"];
export const statusAtivos = ["nao_iniciado", "em_andamento", "aprovado"];
export const statusInativos = ["concluido", "cancelado", "suspenso"];

export const matrizLabels = {
  intervir: "Intervir",
  agir: "Agir",
  ideal: "Ideal",
  apoiar: "Apoiar",
  questionar: "Questionar",
  cancelar: "Cancelar",
  sem_classificacao: "Sem classificação",
};

export function fmtMoeda(v) {
  return Number(v || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function saudeLabel(saude) {
  if (saude === "vermelho") return "Risco";
  if (saude === "amarelo") return "Atenção";
  if (saude === "verde") return "Saudável";
  return "—";
}
